import { createContext } from "react";

const CustomerPostContext = createContext({});

export default CustomerPostContext;
